import React, { useContext } from "react"
import LegalDocumentContent from "../CommonComponents/LegalDocument/LegalDocumentContent"
import TermsAndPolicyModal from "./TermsAndPolicyModal"
import { networkService } from "../config/axios"
import UserInfoContext from "../../utils/userInfoContext"
import { csrfToken } from "../../utils/csrfTokenUtils"
import Button from "../Elements/Button"

const TermsModals = ({ openTerms, setOpenTerms, refetch, onTermsAccepted }) => {
    const { userInfoData, showCreateTerms, setShowCreateTerms, setShowNotifications } = useContext(UserInfoContext)
    const privacyNeedsAgreement = !userInfoData?.privacy_accepted || !!userInfoData?.privacy_reaccept_required
    const termsNeedsAgreement = !userInfoData?.tos_accepted_date || !!userInfoData?.terms_reaccept_required

    //accept the terms while creating first kdf 
    const handleAcceptTerms = async () => {
        const data = {
            authenticity_token: csrfToken(),
        };
        await networkService(`update_tos.json`, "POST", data)
            .then((response) => {
                if (response.status == 200) {
                    refetch()
                    setShowNotifications({
                        showToast: true,
                        toastType: "success",
                        toastMessage: "Terms of Service accepted",
                    });
                    onTermsAccepted?.()
                }
                setShowCreateTerms(false)
            })
            .catch((error) => {
                setShowNotifications({
                    showToast: true,
                    toastType: "danger",
                    toastMessage:
                        error?.response?.data?.errors?.email[0] ?? "Something went wrong",
                });
            });
    };

    //accept the terms policy
    const handleAcceptPolicyTerms = async () => {
        if (!userInfoData?.id) {
            setOpenTerms(false);
            return;
        }
        const data = {
            authenticity_token: csrfToken(),
            id: userInfoData?.id,
            user: {
                privacy_accepted: true
            },
        };
        await networkService(`admin/users/${userInfoData?.id}.json`, "PATCH", data)
            .then((response) => {
                if (response.status == 200) {
                    refetch()
                    setShowNotifications({
                        showToast: true,
                        toastType: "success",
                        toastMessage: "Privacy Notice accepted",
                    });
                }
                setOpenTerms(false)
            })
            .catch((error) => {
                setShowNotifications({
                    showToast: true,
                    toastType: "danger",
                    toastMessage:
                        error?.response?.data?.errors?.email[0] ?? "Something went wrong",
                });
                setOpenTerms(false);
            });
    };

    return (
        <>
            {/* <MyProfileModal
                profileModalStaus={profileModalStaus}
                setProfileModalStaus={setProfileModalStaus}
                setOpenTerms={setOpenTerms}
            /> */}
            <TermsAndPolicyModal
                modalStatus={openTerms}
                modalActiveStatus={setOpenTerms}
                title={userInfoData?.privacy_reaccept_required ? "We have updated our Privacy Notice" : "Privacy Notice"}
                showCloseButton={true}
                footer={(hasScrolledToBottom) => (
                    <div className="d-flex justify-content-between align-items-center w-100">
                        {!privacyNeedsAgreement ? (
                            <div className="d-flex justify-content-end w-100">
                                <Button
                                    classList={'success'}
                                    onClick={() => setOpenTerms(false)}
                                    text='Close'
                                    type="button"
                                />
                            </div>
                        ) : (
                            <>
                                <span className="text-muted" style={{ fontSize: '0.875rem' }}>Please scroll down to read the entire document.</span>
                                <Button
                                    classList={'success'}
                                    type="submit"
                                    onClick={() => handleAcceptPolicyTerms()}
                                    text='I Agree'
                                    disabled={!hasScrolledToBottom}
                                />
                            </>
                        )}
                    </div>
                )}
            >
                <LegalDocumentContent kind="privacy" />
            </TermsAndPolicyModal>
            <TermsAndPolicyModal
                modalStatus={showCreateTerms}
                modalActiveStatus={() => setShowCreateTerms(false)}
                title={userInfoData?.terms_reaccept_required ? "We have updated our Terms of Service" : termsNeedsAgreement ? "Before we can allow full access, please accept our Terms of Service" : "Terms of Service"}
                showCloseButton={!termsNeedsAgreement}
                footer={
                    <div className="d-flex justify-content-end">
                        {!termsNeedsAgreement ? (
                            <Button
                                classList={'success'}
                                onClick={() => setShowCreateTerms(false)}
                                text='Close'
                                type="button"
                            />
                        ) : (
                            <Button
                                classList={'success'}
                                onClick={() => handleAcceptTerms()}
                                text='I Agree'
                                type="submit"
                            />
                        )}
                    </div>
                }
            >
                <LegalDocumentContent kind="terms" />
            </TermsAndPolicyModal>
        </>
    )
}
export default TermsModals
